/* eslint-disable no-console */
import axios from 'axios';
import {UploadRequestOption as RcCustomRequestOptions} from 'rc-upload/lib/interface';

import {API_BASE_URL} from '../../../config';
import base64Encode from '../../../shared/base64encoder';
import useUserStore from '../../../store/userStore/userStore';

interface UploadDocumentPayload {
  file: Blob;
  companyId: string;
  selectedYear: string;
  framework?: string;
  onProgress?: RcCustomRequestOptions['onProgress'];
}

const uploadDocumentAPI = async ({
  file,
  companyId,
  selectedYear,
  framework,
  onProgress
}: UploadDocumentPayload): Promise<any> => {
  const token = useUserStore.getState().userToken;
  let fileName = '';
  let mimetype = '';
  if (file instanceof File && file.name) {
    fileName = file.name;
    mimetype = file.type;
  }

  const response = await axios.request({
    method: 'POST',
    url: `${API_BASE_URL}/cdpcorporate/uploadFile/${companyId}/${selectedYear}/${framework}`,
    data: {
      file: await base64Encode(file).then((result) => {
        return result;
      }),
      originalFilename: fileName,
      mimetype
    },
    headers: {
      Authorization: `Bearer ${token}`
    },
    onUploadProgress: (progressEvent) => {
      if (!onProgress) return;
      const total = progressEvent.total ?? 0;
      const percent = total
        ? Math.round((progressEvent.loaded * 100) / total)
        : 0;
      onProgress({percent});
    }
  });

  return response.data;
};

export default uploadDocumentAPI;
